(function($){

    var initializeBlock = function( $block ) {
        //console.log('tabs-js');
		//$block.find('img').doSomething();
        new WPK_Tabs($block);

    };

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        $('.wpk-block-tabs').each(function(){
            initializeBlock( $(this) );
        });
    });

    // Initialize dynamic block preview (editor).
    if( window.acf ) {
        window.acf.addAction( 'render_block_preview/type=tabs', initializeBlock );
    }

})(jQuery);


//************************
//TABS
//************************
var WPK_Tabs = function ($tabsElement) {

    this.tabs = $tabsElement;

    // tabs elems
    this.tabNavs = $tabsElement.find('.wpk-tab');
	
	// tabs mobile title
	this.tabTitle = $tabsElement.find('.wpk-tab-mobile');

    // content items
    this.items = $tabsElement.find('.wpk-tab-pane');

    //Get user agent funtion support for mobile
	var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

    //If we dont have a mobile, show first tab
	if(!supportsTouch) {

        //Default to first tab
		var index = 0;

		//If we link directly to a certain tab
		if(window.location.hash) {

			//Get the url hash value
			var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

			//If tab element exist
			if(document.getElementById(hash)) {

				//Items object from above
				let obj = this.items;

				//Create empty array
				let tabArray = [];

				//Loop through object items
				for (var i = 0; i < obj.length; i++) {
					//Fill array with index and id from children
					tabArray[i] = obj[i].id;
				}
				//Get the index value from element id. If null open first tab
				index = (tabArray.indexOf(hash) === -1) ? 0 : tabArray.indexOf(hash);

			}

		}

		this.show(index);
		
	}

    // init events
    this.initEvents();
	
};

//Regular
WPK_Tabs.prototype.show = function (index) {

		// Clear out existing tab
		this.tabNavs.removeClass('wpk-active');
		this.tabTitle.removeClass('wpk-active');
		this.items.removeClass('wpk-active');
	
		//View current tab 
		this.tabNavs.eq(index).addClass('wpk-active');
		this.tabTitle.eq(index).addClass('wpk-active');
		this.items.eq(index).addClass('wpk-active');
	
};

//Mobile
WPK_Tabs.prototype.mobileShow = function (index) {

	//Use to hide current tab if it is clicked ( toogle function)
	if(this.tabTitle.eq(index).hasClass('wpk-active')){
		// Clear out existing tab
		this.tabTitle.removeClass('wpk-active');
		this.items.removeClass('wpk-active');
	} else {
		// Clear out existing tab
		this.tabTitle.removeClass('wpk-active');
		this.items.removeClass('wpk-active');
		//View current tab 
		this.tabTitle.eq(index).addClass('wpk-active');
		this.items.eq(index).addClass('wpk-active');
	}
	
};

WPK_Tabs.prototype.initEvents = function () {

    var self = this;

	//Regular
    this.tabNavs.click(function (event) {

        event.preventDefault();

        var $anchor = jQuery(this).children('a').eq(0);

        var target = $anchor.attr('href').split('#').pop();

        self.show(self.tabNavs.index(jQuery(this)));

        //history.pushState ? history.pushState(null, null, "#" + target) : window.location.hash = "#" + target;

        if (history.pushState) {
            history.pushState(null, null, "#" + target);
        } else {
            window.location.hash = "#" + target;
        }
    });
	
	//Mobile tab
	this.tabTitle.click(function (event) {

        event.preventDefault();

        self.mobileShow(self.tabTitle.index(jQuery(this)));

    });

};

